"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorHelper = void 0;
var ColorHelper = /** @class */ (function () {
    function ColorHelper() {
    }
    ColorHelper.brightness = function (hexCode) {
        hexCode = hexCode.replace("#", "");
        var red = parseInt(hexCode.substr(0, 2), 16);
        var green = parseInt(hexCode.substr(2, 2), 16);
        var blue = parseInt(hexCode.substr(4, 2), 16);
        return (red * 299 + green * 587 + blue * 114) / 255000;
    };
    return ColorHelper;
}());
exports.ColorHelper = ColorHelper;
//# sourceMappingURL=ColorHelper.js.map